import type { HasuraClient } from '@vrplatform/graphql';
import type { StatementInput } from '@vrplatform/ui-common';
import { pdf as renderPdf } from '@react-pdf/renderer';
import { downloadBlob, type FileTransferDisposition } from '../../../../utils';

export const getOwnerStatementPdf = async ({
  hasura,
  input,
  opts = {
    autoDownload: true,
    disposition: 'download' as FileTransferDisposition,
  },
}: {
  hasura: HasuraClient;
  input: StatementInput;
  opts?: {
    autoDownload?: boolean;
    disposition?: FileTransferDisposition;
  };
}) => {
  const { statementPdf: generateStatement } = await import(
    './components/statement'
  );
  const { statement, filename } = await generateStatement({
    hasura,
    input,
  });

  const p = renderPdf(statement);
  const blob = await p.toBlob();

  if (opts.autoDownload) {
    downloadBlob(blob, filename, {
      disposition: opts.disposition,
    });

    return {
      url: undefined,
      filename,
      blob,
    };
  }

  const url = window.URL.createObjectURL(blob);

  return {
    url,
    filename,
    blob,
  };
};
